import React from 'react';
import { FormControl, FormLabel, NumberInput, NumberInputField, Select, Switch } from '@chakra-ui/react';

const durationTypes = ['SECONDS', 'MINUTES', 'HOURS', 'WEEKS', 'DAYS'];

const BasicSettings = ({ formik }) => {
  return (
    <>
      <FormControl>
        <FormLabel>Delay Duration</FormLabel>
        <NumberInput min={0}>
          <NumberInputField
            name="delay.duration"
            value={formik.values.delay.duration}
            onChange={(valueString) => formik.setFieldValue('delay.duration', valueString.target.value)}
          />
        </NumberInput>
      </FormControl>
      <FormControl>
        <FormLabel>Delay Duration Type</FormLabel>
        <Select name="delay.durationType" value={formik.values.delay.durationType} onChange={formik.handleChange}>
          {durationTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Disappear Status</FormLabel>
        <Switch name="disappear.status" isChecked={formik.values.disappear.status} onChange={formik.handleChange} />
      </FormControl>
      <FormControl>
        <FormLabel>Disappear Duration</FormLabel>
        <NumberInput min={0}>
          <NumberInputField
            name="disappear.duration"
            value={formik.values.disappear.duration}
            onChange={(valueString) => formik.setFieldValue('disappear.duration', valueString.target.value)}
          />
        </NumberInput>
      </FormControl>
      <FormControl>
        <FormLabel>Disappear Duration Type</FormLabel>
        <Select name="disappear.durationType" value={formik.values.disappear.durationType} onChange={formik.handleChange}>
          {durationTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </Select>
      </FormControl>
      <FormControl>
        <FormLabel>Interval Duration</FormLabel>
        <NumberInput min={0}>
          <NumberInputField
            name="interval.duration"
            value={formik.values.interval.duration}
            onChange={(valueString) => formik.setFieldValue('interval.duration', valueString.target.value)}
          />
        </NumberInput>
      </FormControl>
      <FormControl>
        <FormLabel>Interval Duration Type</FormLabel>
        <Select name="interval.durationType" value={formik.values.interval.durationType} onChange={formik.handleChange}>
          {durationTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default BasicSettings;